<template>
<div>
	<el-dialog title="粮情检测" :visible="dialogVisible" top='0.69rem' @close='close'>
		<div>
			<div class="data-title">{{dialogData.companyName}}-{{dialogData.warehouseName}}</div>
			<div class="data-plane">
				<el-row  style='width:100%;margin: 0;' type="flex" justify="space-between">
					<el-col :span="6">
						<div class="data-plane-list">
							<div class="data-plane-item">
								<span class="value">{{dialogData.materialsTypeName||'-'}}</span>
								<span class="name">粮食品种</span>
							</div>
							<div class="data-plane-item">
								<span class="value">{{dialogData.inventoryWeight||'-'}}</span>
								<span class="name">总吨数(吨)</span>
							</div>
						</div>
					</el-col>
					<el-col :span="11">
						<div class="data-plane-list">
							<div class="data-plane-item">
								<span class="value">{{dialogData.currentTemperature||'-'}}℃</span>
								<span class="name">仓内温度</span>
							</div>
							<div class="data-plane-item">
								<span class="value">{{dialogData.maxTemperature||'-'}}℃</span>
								<span class="name">最高温度</span>
							</div>
							<div class="data-plane-item">
								<span class="value">{{dialogData.minTemperature||'-'}}℃</span>
								<span class="name">最低温度</span>
							</div>
							<div class="data-plane-item">
								<span class="value">{{dialogData.aveTemperature||'-'}}℃</span>
								<span class="name">平均温度</span>
							</div>
						</div>
					</el-col>
					<el-col :span="6">
						<div class="data-plane-list">
							<div class="data-plane-item">
								<span class="value">{{dialogData.currentHumidity||'-'}}</span>
								<span class="name">仓内湿度</span>
							</div>
							<div class="data-plane-item" v-if='dialogData.updateTime'>
								<span class="name" style="text-align: center;">{{dialogData.updateTime.split(' ')[0]}}</span>
								<span class="name" style="text-align: center;">{{dialogData.updateTime.split(' ')[1]}}</span>
								<span class="name" style="text-align: center;">最近更新时间</span>
							</div>
						</div>
						
					</el-col>
					
				</el-row>
				
				
				
			</div>
			<div class="chart">
				<div class="chart-left" style="display: flex;flex-direction: column-reverse;justify-content: flex-end;">
					<!-- <el-checkbox-group @change='onChange' v-model="checkGroup" style="display: flex;flex-direction: column;"> -->
						<el-checkbox v-if='dialogData.floorNum>=item.index' v-for="item in checkList" @change='onChange' v-model="item.value"  :key="item.index"  :label="item.index">{{item.name}}</el-checkbox>
						<!-- <el-checkbox label="3">第三层</el-checkbox>
						<el-checkbox label="2">第二层</el-checkbox>
						<el-checkbox label="1">第一层</el-checkbox> -->
					<!-- </el-checkbox-group> -->
				</div>
				<div class="chart-center" id='chart'></div>
				<div class="chart-right" style="justify-content: flex-end;">
					<div class="btn" @click="isShow=true">
						历史温度
					</div>
				</div>
			</div>
		</div>
	</el-dialog>
	<lineChart :isShow="isShow" @close="isShow=false"></lineChart>

</div>

</template>

<script>
	// import {
	// 	chartData
	// } from './data.js';
	import lineChart from './lineChart.vue'
	export default {
		props: {
			dialogVisible: {
				type: Boolean,
				default: false
			},
			dialogData:{
				type: Object,
				default:{}
			}
		},
		data() {
			return {
				checkList: [
					{name:'第一层',value:true,index:'1'},
					{name:'第二层',value:true,index:'2'},
					{name:'第三层',value:true,index:'3'},
					{name:'第四层',value:true,index:'4'},
					{name:'第五层',value:true,index:'5'},
					{name:'第六层',value:true,index:'6'},
					{name:'第七层',value:true,index:'7'},
					{name:'第八层',value:true,index:'8'},
				],
				checkGroup:[],
				isShow:false,
				chart:null
			}
		},
		components:{lineChart},
		watch: {
			dialogVisible(n) {
				if (n) {
					this.$nextTick(() => {
						this.initChart()
						
					})
				}
				console.log(n)
			}
		},
		created() {
			

		},
		methods: {
			close(){
				console.log(111)
				console.log(this.$parent)
				// if(this.chart){
				// 	console.log(this.chart)
				// 	this.chart.dispose()
				// 	this.chart=null
				// }
				this.$parent.dialogVisible=false
				console.log(222)
			},
			onChange(val){
				console.log(val)
				console.log(this.checkList)
				
				this.checkList.forEach(item=>{
					let i={
						series: [{
							id: item.index,
							itemStyle: {
								opacity: item.value  ? 1 : 0
							}
						}]
					}
					this.chart.setOption(i)
				})
				
			},
			generateData(rowIndex) {
				var data = [];
				// console.log('第',rowIndex,'层')
				
				
				
				this.dialogData.solidList.forEach(item => {
					// console.log(item.coordinate[2],rowIndex)
					
					if(item.coordinate[2]==rowIndex){
						item.coordinate[2]=1
						data.push({
							name: "数据",
							value: item.coordinate,
							itemStyle: {
								// width: 2,
								// height: 200,
								color: this.getColor(item.temperature),
							},
							label: {
								show: true,
								distance: -30,
								formatter: function() {
									return item.temperature + "℃"
								},
								textStyle: {
									color: this.getColor(item.temperature),
									fontWeight: "bolder",
									fontSize: 14
								}
							},
							tooltip: {
								formatter: function() {
									return item.temperature + "℃<br/>x: 第" + item.coordinate[0] + "层<br/>y: 第" + item
										.coordinate[1] + "层<br/>z: 第" + rowIndex + "层<br/>"
								}
							}
						});
					}
					
				})

				// console.log('处理之后数据',data)
				return data;
			},
			getColor(val){
				if(val<this.dialogData.temperatureMin){
					return '#19ECFF'
				}
				if(val>this.dialogData.temperatureMin&&val<this.dialogData.temperatureMax){
					return '#176ee3'
				}
				if(val>this.dialogData.temperatureMax){
					return '#eb3f3f'
				}
			},
			initChart() {
				var series = [];
				let storey = this.dialogData.floorNum //层
				for (var i = 1; i <= storey; i++) {
					
					series.push({
						type: 'bar3D',
						id: i,
						data: this.generateData(i),
						stack: 'stack',
						shading: 'color',
						barSize: [1, 1],
						// barWidth: 1,
						// barSize: 1,
						// minHeight: 1,
						emphasis: {
							label: {
								show: true,
							},
						},
					});
				}
			
				// myChart.restore();
				
				this.chart = this.$echarts.init(document.getElementById('chart'));
				this.chart.setOption({
					tooltip: {
						trigger: "item"
					},
					xAxis3D: {
						type: "value",
						name: "行",
						min: 1,
						minInterval: 1,
						splitArea: {
							show: !0,
							areaStyle: {
								color: ["#293950"]
							}
						},
						axisLabel: {
							show: !0,
							textStyle: {
								color: "#fff"
							}
						},
						axisLine: {
							show: !0,
							lineStyle: {
								color: "#fff"
							}
						}

					},
					yAxis3D: {
						type: "value",
						name: "列",
						min: 1,
						minInterval: 1,
						axisLabel: {
							show: !0,
							textStyle: {
								color: "#fff"
							}
						},
						axisLine: {
							show: !0,
							lineStyle: {
								color: "#fff"
							}
						}
					},
					zAxis3D: {
						type: "value",
						name: "层",
						minInterval: 1,
						splitArea: {
							show: !0,
							areaStyle: {
								color: ["#afc1cd"]
							}
						},
						axisLabel: {
							show: !0,
							textStyle: {
								color: "#fff"
							}
						},
						axisLine: {
							show: !0,
							lineStyle: {
								color: "#fff"
							}
						}
					},
					grid3D: {
						viewControl: {
							projection: "orthographic",
							rotateSensitivity: 1,
							orthographicSize: 300,
							zoomSensitivity: 1,
							minAlpha: 0,
							alpha: 30,
							beta: -30,
							distance: 600
						},
						axisPointer: {
							show: !1
						},
						boxHeight: 120,
						boxWidth: 400,
						boxDepth: 140,
						light: {
							main: {
								shadow: !0,
								quality: "ultra",
								intensity: 1.5
							}
						}

					},
					series: series,
				});
			},
		}
	}
</script>

<style lang="scss" scoped>
	::v-deep .el-dialog {
		background: #081D31;
		opacity: 1;
		border: 0.01rem solid #1B475B;
		width: 15.25rem;
		box-sizing: border-box;
		.el-dialog__body {
			box-sizing: border-box;
			padding: 0.34rem;
		}
	}
	::v-deep .el-dialog__title,::v-deep .el-dialog__close{
		color:#fff;
	}
	::v-deep .el-checkbox{
		margin-bottom: 0.18rem;
	}
	::v-deep .el-checkbox__label{
		color:#fff !important;
	}
	::v-deep .el-checkbox__input.is-checked .el-checkbox__inner,::v-deep  .el-checkbox__input.is-indeterminate .el-checkbox__inner{
		    background-color: #19ECFF;
		    border-color: #19ECFF;
	}
	::v-deep .el-checkbox__inner::after{
		border-color:rgb(3,18,40);
	}
	.data-title {
		height: 0.23rem;
		font-size: 0.3rem;
		font-family: Source Han Sans-Medium, Source Han Sans;
		font-weight: 500;
		color: #FFFFFF;
		line-height: 0.23rem;
		padding-bottom: .3rem;
		box-sizing: content-box;

	}

	.data-plane {
		display: flex;
		justify-content: space-between;

		.data-plane-list {
			padding: 0.23rem 0.28rem;
			height: 1.38rem;
			background: rgba(25, 236, 255, 0.06);
			border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
			display: flex;
			// margin-right: 0.24rem;
			.data-plane-item {
				flex:1;
				display: flex;
				flex-direction: column;
				justify-content: space-between;

				.name {
					height: 0.25rem;
					font-size: 0.18rem;
					font-family: Source Han Sans-Normal, Source Han Sans;
					font-weight: 350;
					color: #FFFFFF;
					line-height: 0.25rem;
				}

				.value {
					height: 0.48rem;
					font-size: 0.33rem;
					font-family: Source Han Sans-Bold, Source Han Sans;
					font-weight: 700;
					color: #19ECFF;
					line-height: 0.48rem;
				}
			}
		}
	}

	.chart {
		display: flex;
		box-sizing: border-box;
		height: 8.5rem;
		background: rgba(25, 236, 255, 0.06);
		border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
		margin-top: 0.25rem;
		padding: 0.25rem;

		.chart-left,
		.chart-right {
			flex: 1;
			display: flex;

			.btn {
				text-align: center;
				width: 0.81rem;
				height: 0.3rem;
				line-height: 0.3rem;
				background: rgba(25, 236, 255, 0.15);
				border-radius: 0.03rem 0.03rem 0.03rem 0.03rem;
				// opacity: 0.15;

				// height: 0.13rem;
				font-size: 0.18rem;
				font-family: Source Han Sans-Regular, Source Han Sans;
				font-weight: 400;
				color: #19ECFF;
				cursor: pointer;
				// line-height: 0.13rem;
			}
		}

		.chart-center {
			// width: 11.48rem;
			width: 100%;
			height: 8.1rem;
		}
	}
	.el-col{
		// padding: 0 !important;
	}
</style>